<template>
    <div class="activity-content activity-xc-content">
        <div class="activity-banner">
            <img src="../../assets/images/xc-banner@2x.png" alt />
            <a
                v-if="$route.query.type!='mirror2'"
                href="javascript:;"
                class="go-back activity-back"
                @click="e=>this.$router.push('/activity')"
            ></a>
        </div>
        <div class="activity-list">
            <div class="new-a-list-item">
                <div class="new-wrap">
                    <h5>活动主题一</h5>
                    <p>
                        鑫驰白金卡中石化
                        <span>加油8.5折</span>全新升级！
                    </p>
                    <p>
                        活动延续至年底，
                        <span>更新增无消费门槛10%加油返现。</span>
                    </p>
                </div>
            </div>
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/hfcz-icon-1@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动时间</h5>
                    <div class="text-item-warp">
                        <div class="text-item">2020年1月1日-2020年12月31日</div>
                        <div class="apply-button-wrapper">
                            <a
                                href="javascript:;"
                                @click="e=>this.changeTestLink('jy')"
                                class="apply-activity-btn"
                            ></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/hfcz-icon-2@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动对象</h5>
                    <div class="text-item-warp">
                        <div class="text-item">上海地区鑫驰白金卡持卡人</div>
                    </div>
                </div>
            </div>
            <div class="a-list-item wsd-list">
                <div class="item-wrap-xc">
                    <div class="item-main-xc">
                        <div class="left-item">
                            <img src="../../assets/images/xc-icon-1@2x.png" class="a-item-icon" alt />
                        </div>
                        <div class="right-item">
                            <h5>活动内容</h5>
                            <div class="text-item-warp">
                                <p>
                                    <span>“中石化加油返现”</span>活动升级
                                </p>
                                <div class="new-text-item">
                                    鑫驰白金卡持卡人通过我行信用卡微信公众号完成活动注册，即可享中石化
                                    <span>10%加油金返还</span>优惠；当月非加油类消费达标,即可参与中石化最高
                                    <span>15%加油金返还</span>优惠，每月最高返还
                                    <span>300元</span>加油金。
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src="../../assets/images/xc-table@2x.png" class="xc-table" alt />
                    <div class="item-tips">
                        <h5>注意事项</h5>
                        <div class="tips-content">
                            <p>鑫驰白金卡持卡人参与本活动，须关注我行信用卡微信公众号,并在我行信用卡微信公众号回复“加油”，进入“鑫驰白金卡加油”专属页面并录入相关信息进行活动注册。</p>
                            <p>加油卡注册成功后，我行将以短信或其他形式通知持卡人，持卡人在收到加油卡注册成功的通知后，可使用本人鑫驰白金卡通过活动指定渠道为其注册的本人中石化个人记名单用户加油卡刷卡充值。持卡人当月分别满足加油卡刷卡充值达标和非加油类消费达标条件后，可参与相应活动。每位持卡人每月仅可参与活动一次，并默认持卡人享受与其当月非加油净消费金额相对应的折扣。</p>
                        </div>
                    </div>
                    <!-- <span class="line tips-line"></span> -->
                    <div class="rule-details">
                        <h5>活动细则</h5>
                        <div class="rule-text">
                            <p>1.本活动仅限上海农商银行鑫驰白金卡个人卡参加。</p>
                            <div class="more-text" v-show="isShow1">
                                <p>2.本活动仅限持卡人本人在上海地区办理的中石化个人记名单用户加油卡参加，不记名卡、单位卡和个人多用户卡不参与本活动。</p>
                                <p>3.参与活动前，即持卡人刷卡充值加油卡前，须通过我行信用卡微信公众号完成绑定（微信搜索公众号“上海农商银行信用卡”点击关注），同时在我行信用卡微信公众号回复“加油”，进入“鑫驰白金卡加油”专属页面并录入相关信息进行活动注册。加油卡注册成功后，我行将以短信或其他形式通知持卡人。持卡人在收到注册成功的通知后，方可参与活动。</p>
                                <p>4.参与活动的持卡人须使用本人鑫驰白金卡在上海地区中石化线下指定充值网点（自助充值机除外）以及中国石化网上营业厅（www.sinopecsales.com）、中国石化加油卡掌上营业厅APP，为其本人名下已绑定成功的上海地区发行的中石化个人记名单用户加油卡刷卡充值。刷卡充值渠道仅限银联支付渠道（第三方支付渠道除外）。</p>
                                <p>5.活动奖励将于持卡人满足活动条件后的60天内返还至持卡人注册成功的中石化个人记名单用户加油卡内。每位持卡人每月仅可参与活动一次，并默认持卡人享受与其当月非加油净消费金额相对应的折扣。优惠返利仅限中石化加油站内持卡消费，不可折现，不可清户退款（清户退款退款时，仅可退回客户充值的本金部分）。</p>
                                <p>6.奖励返还后，我行将以短信或其他形式通知符合条件的持卡人，符合条件的持卡人须前往中石化加油网点完成“圈存”后方可使用。具体“圈存”操作可咨询中国石化客服热线95105888。优惠返利金不可清户退款。</p>
                                <p>7.上述我行指定中石化充值网点，请详询中国石化上海客服热线95105888/95105999，或登陆中国石化网上营业厅官方网站 http://www.sinopecsales.com/查询。</p>
                                <p>8.本活动注册的个人记名单用户加油卡不可同时参加中石化其他营销活动，如持卡人同时符合我行其他卡种中石化营销活动，我行将默认持卡人参与奖励幅度最大的活动。</p>
                                <p>9.持卡人知晓并同意，上海农商银行有权对持卡人用卡、还款、资信及风险状况进行综合评估。持卡人如有下述任何一种情况，其享受本活动的资格将被取消，包括但不限于当前账户出现欠款逾期、销户、冻结及其他非正常状态；出现所持信用卡过期、被停用、管制、持卡人自行注销信用卡、违反《上海农商银行信用卡章程》及《上海农商银行信用卡（个人卡）领用合约》或本活动细则及相关规定的。</p>
                                <p>10.如持卡人发生任何虚假、欺诈、套现、用于经营性目的等不正常交易，或持卡人存在任何违反《上海农商银行信用卡章程》、《上海农商银行信用卡（个人卡）领用合约》约定的行为，或持卡人账户发生逾期、限制或停止用卡、风险管控、销卡等非正常状态、或持卡人在出现疑似不正常交易但拒绝配合上海农商银行进行调查，或符合本活动条件的交易最终被撤销或退货的，则上海农商银行保留对相关交易进行调查核实、拒绝该持卡人参加本活动的权利。</p>
                                <p>11.在法律许可范围内，上海农商银行有权按季度修订本活动条款及细则（包括但不限于参加资格、消费时间及奖励方式等）、暂停或取消本活动，并经相关途径（如上海农商银行官方网站、对账单、短信、信用卡微信公众号或各分支网点等）提前公告后生效。活动详情以上海农商银行最新公布内容为准，或咨询24小时客服热线021-962999或4006962999。</p>
                                <p>12.其他未尽事宜，仍受《上海农商银行信用卡章程》、《上海农商银行信用卡（个人卡）领用合约》、监管机构及银行卡组织相关规定约束。</p>
                            </div>
                        </div>
                        <a
                            href="javascript:;"
                            class="more-rule"
                            @click="e=>this.changeMoreRule('isShow1')"
                            v-show="!isShow1"
                        >展开详情</a>
                        <div class="collect-wrap" v-show="isShow1">
                            <div class="collect-btn" @click="e=>this.changeMoreRule('isShow1')">
                                <i class="collect-icon"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="item-wrap-xc">
                    <div class="item-main-xc">
                        <div class="left-item">
                            <img
                                src="../../assets/images/xc-icon-2@2x.png"
                                class="a-item-icon"
                                alt
                            />
                        </div>
                        <div class="right-item">
                            <div class="text-item-warp">
                                <p>
                                  <span>0手续费</span>车险分期活动
                                </p>
                                <div class="text-item">
                                    持卡人使用本人鑫驰白金卡进行车险交易,可申请4期0手续费分期,全年不限笔数,不限金额。
                                </div>
                                <div class="text-tips">
                                    注：教你一招识别车险POS消费：可查看刷卡签购单上“商户编号”的第8位至第11位,如与细则中的MCC码相一致即可申请0手续费分期。
                                </div>
                            </div>
                        </div>
                    </div>
                    <span class="line tips-line"></span>
                </div>
                 <div class="item-wrap-xc">
                    <div class="item-main-xc">
                        <div class="left-item">
                            <img
                                src="../../assets/images/xc-icon-3@2x.png"
                                class="a-item-icon"
                                alt
                            />
                        </div>
                        
                        <div class="right-item">
                            <div class="text-item-warp">
                                <p>
                                 <span>年费</span>活动
                                </p>
                                <div class="text-item">
                                   首年年费不减免,当年消费笔数满10笔且金额满5000元,或消费笔数满36笔不限金额可减免次年年费。
                                </div>
                                <div class="text-tips">
                                   注：消费交易包含线下POS交易及线上支付。  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>-->
            </div>
            <span class="line new-tips-line"></span>
        </div>
        <div class="activity-list">
            <div class="new-a-list-item">
                <div class="new-wrap">
                    <h5>活动主题二</h5>
                    <p>
                        鑫驰白金卡激活即送
                        <span>5400元途虎养车大礼包</span>活动
                    </p>
                </div>
            </div>
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/hfcz-icon-1@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动时间</h5>
                    <div class="text-item-warp">
                        <div class="text-item">2020年6月1日-2020年12月31日</div>
                        <div class="apply-button-wrapper">
                            <a
                                href="javascript:;"
                                @click="e=>this.changeTestLink('th')"
                                class="apply-activity-btn"
                            ></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/hfcz-icon-2@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动对象</h5>
                    <div class="text-item-warp">
                        <div class="text-item">鑫驰白金卡持卡人</div>
                    </div>
                </div>
            </div>
            <div class="a-list-item wsd-list">
                <div class="item-wrap-xc">
                    <div class="item-main-xc">
                        <div class="left-item">
                            <img src="../../assets/images/xc-icon-2@2x.png" class="a-item-icon" alt />
                        </div>
                        <div class="right-item">
                            <h5>活动内容</h5>
                            <div class="text-item-warp">
                                <p>
                                    激活即送
                                    <span>5400元途虎养车大礼包</span>
                                </p>
                                <div class="text-item">活动期间，首次成功激活本行鑫驰白金卡的持卡人，可获5400元途虎大礼包。</div>
                            </div>
                        </div>
                    </div>
                    <img src="../../assets/images/xc-table-2@2x.png" class="xc-table" alt />
                    <div class="item-tips">
                        <h5>小贴士：</h5>
                        <div class="tips-content">
                            <p>礼包使用规则和有效期以“途虎养车APP”载明为准。优惠券可通过在“途虎养车APP”中用券下单预约，持卡人需要通过用券在线上预约的方式，到上海地区内部分途虎合作门店（以“途虎养车APP”显示为准）享受服务。</p>
                        </div>
                    </div>

                    <div class="rule-details">
                        <h5>活动细则</h5>
                        <div class="rule-text">
                            <p>1.本次活动对象为本行鑫驰白金卡持卡人，优享白金鑫卡（车牌分期）或鑫驰白金卡（车牌分期）持卡人不纳入本次活动范围。</p>
                            <div class="more-text" v-show="isShow2">
                                <p>2.持卡人首次成功激活本行鑫驰白金卡后10个工作日内，持卡人可获得“途虎养车大礼包”，持卡人仅需通过鑫驰白金卡预留手机号登录“途虎养车APP”—我的—优惠券入口，即可查看。优惠券不支持拼团使用；优惠券使用规则以“途虎养车APP”载明为准。</p>
                                <p>3.优惠券使用规则：</p>
                                <p>a)适用车型：7座（含）以下家用非营运轿车。</p>
                                <p>b)不适用车型：营运性质车辆，包括但不限于货车、出租车、单位用车、租赁用车等。</p>
                                <p>c)优惠券仅限在“途虎养车APP”使用，并仅限在途虎合作门店完成使用；不得兑换其他产品或服务，不可兑换现金。</p>
                                <p>d)优惠券使用有效期以券面显示为准，过期作废。</p>
                                <p>4.持卡人知晓并同意，上海农商银行有权对持卡人用卡、还款、资信及风险状况进行综合评估。持卡人如有下述任何一种情况，其享受本活动的资格将被取消，包括但不限于当前账户出现欠款逾期、销户、冻结及其他非正常状态；出现所持信用卡过期、被停用、管制、持卡人自行注销信用卡、违反《上海农商银行信用卡章程》及《上海农商银行信用卡（个人卡）领用合约》或本活动细则及相关规定的。</p>
                                <p>5.如发现持卡人参与活动过程中存在任何利用系统漏洞或规则漏洞、外挂软件、插件等手段或工具套取活动奖励、损害活动规则、违背活动公平原则、违背诚实信用原则、扰乱正常活动秩序等行为的，包括但不限于使用外挂获取活动资格、恶意刷单、有偿转赠权益、与商户串通、倒卖活动奖励、冒用他人信息参与活动、进行虚假交易等，上海农商银行有权取消持卡人参加本次活动及获得本活动奖励的资格，并有权取消或收回其因参加本次活动所获的奖励。同时，上海农商银行保留追求其法律责任的权利。若系统漏洞、故障或其他原因致使系统无法正常运行，导致持卡人获得与本活动规则不符的奖励，上海农商银行保留取消或收回持卡人参加本活动所获的回馈和奖励权利。</p>
                                <p>6.在法律许可范围内，上海农商银行有权修订本活动条款及细则（包括但不限于参加资格、消费时间及奖励方式等）、暂停或取消本活动、并经相关途径（如上海农商银行官方网站、对账单、短信、信用卡微信公众号或各分支网点等）公告后生效。活动详情以上海农商银行最新公布内容为准，或咨询24小时客服热线021-962999或4006962999。</p>
                                <p>7.其他未尽事宜，仍受《上海农商银行信用卡章程》、《上海农商银行信用卡（个人卡）领用合约》、监管机关及银行卡组织相关规定约束。</p>
                                <p>8.活动详情以上海农商银行最新公布内容为准，或咨询24小时客服热线021-962999或4006962999。</p>
                            </div>
                        </div>
                        <a
                            href="javascript:;"
                            class="more-rule"
                            @click="e=>this.changeMoreRule('isShow2')"
                            v-show="!isShow2"
                        >展开详情</a>
                        <div class="collect-wrap" v-show="isShow2">
                            <div class="collect-btn" @click="e=>this.changeMoreRule('isShow2')">
                                <i class="collect-icon"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span class="line new-tips-line"></span>
        </div>

        <div class="activity-list">
            <div class="new-a-list-item">
                <div class="new-wrap">
                    <h5>活动主题三</h5>
                    <ul>
                        <li>
                            <span>0手续费</span>车险分期活动
                        </li>
                        <!-- <li>
                            <span>年费减免</span>活动
                        </li>-->
                    </ul>
                </div>
            </div>
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/hfcz-icon-1@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动时间</h5>
                    <div class="text-item-warp">
                        <div class="text-item">2020年1月1日—2020年12月31日</div>
                        <div class="apply-button-wrapper">
                            <a
                                href="javascript:;"
                                @click="e=>this.changeTestLink('fy')"
                                class="apply-activity-btn"
                            ></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="a-list-item">
                <div class="left-item">
                    <img src="../../assets/images/hfcz-icon-2@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>活动对象</h5>
                    <div class="text-item-warp">
                        <div class="text-item">上海地区鑫驰白金卡持卡人</div>
                    </div>
                </div>
            </div>
            <div class="a-list-item wsd-list">
                <div class="item-wrap-xc">
                    <div class="item-main-xc">
                        <div class="left-item">
                            <img src="../../assets/images/xc-icon-3@2x.png" class="a-item-icon" alt />
                        </div>
                        <div class="right-item">
                            <h5>活动内容</h5>
                            <div class="text-item-warp">
                                <p class="item-xc-title">
                                    <span>0手续费</span>车险分期活动
                                </p>
                                <div class="text-item">持卡人使用本人鑫驰白金卡进行车险交易，可申请4期0手续费分期，全年不限笔数，不限金额。</div>
                                <div
                                    class="text-tips"
                                >注：教你一招识别车险POS消费：可查看刷卡签购单上“商户编号”的第8位至第11位，如与细则中的MCC码相一致即可申请0手续费分期。</div>

                                <span class="line news-line"></span>
                            </div>
                            <div class="text-item-warp">
                                <p class="item-xc-title">
                                    <span>年费减免</span>活动
                                </p>
                                <div class="new-text-item">
                                    活动期间，鑫驰白金卡持卡人可获得
                                    <span>非首年年费减免</span>优惠政策。
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="rule-details">
                        <h5>活动细则</h5>
                        <div class="rule-text">
                            <p>1.持卡人需使用本人鑫驰白金卡进行车险交易，同时交易须满足消费MCC码为：6300、5960、7392和9399。</p>
                            <p>2.持卡人可办理分期业务的保费包括交强险、商业险（包括但不限于车辆损失险、第三者责任险、不计免赔险、车上座位责任险、玻璃单独碎险、划痕险、新增设备损失险、盗抢险、自燃险等）。</p>

                            <div class="more-text" v-show="isShow3">
                                <p>3.持卡人所申请分期付款交易以本行系统实际记录时间为准，并按照自然月进行统计。</p>
                                <p>4.持卡人办理多笔车险分期，每笔符合规则均可申请0手续费分期。</p>
                                <p>5.持卡人可通过我行信用卡微信平台办理车险分期。</p>
                                <p>6.持卡人申请车险分期业务须在消费交易记账日至当期账单日之前2天（不含账单日）提出申请，具体申请结果以本行系统记录为准。</p>
                                <p>7.持卡人可就已分摊的车险分期交易提前还款，届时一次性清偿剩余期数全部本金。</p>
                                <p>8.持卡人须遵守《上海农商银行信用卡灵活分期付款业务条款及细则》。</p>
                                <p>9.持卡人如有下述任何一种情况，其享受本活动的资格将被取消，包括但不限于当前账户出现欠款逾期、销户、冻结及其他非正常状态；出现所持信用卡过期、被停用、管制、持卡人自行注销信用卡、违反《上海农商银行信用卡章程》及《上海农商银行信用卡领用合约》或本活动细则及相关规定的。</p>
                                <p>10.如发现持卡人有利用活动规则或系统漏洞、作弊、冒用他人信息参与活动、进行虚假交易或者违法交易等手段恶意套取优惠奖励的，上海农商银行保留取消该持卡人参加本活动的权利，并有权取消或收回其因参加本活动所获的回馈和奖励。</p>
                                <p>11.在法律许可范围内，上海农商银行有权修订本活动条款及细则（包括但不限于参加资格、消费时间及奖励方式等）、暂停或取消本活动、并经相关途径（如上海农商银行官方网站、对账单、短信、信用卡微信公众号或各分支网点等）公告后生效。</p>
                                <p>12.其他未尽事宜，仍受《上海农商银行信用卡（个人卡）章程》、《上海农商银行信用卡（个人卡）领用合约》及其他相关文件约束。</p>
                                <p>13.活动详情以上海农商银行最新公布内容为准，或咨询24小时客服热线021-962999或4006962999。</p>
                            </div>
                        </div>
                        <a
                            href="javascript:;"
                            class="more-rule"
                            @click="e=>this.changeMoreRule('isShow3')"
                            v-show="!isShow3"
                        >展开详情</a>
                        <div class="collect-wrap" v-show="isShow3">
                            <div class="collect-btn" @click="e=>this.changeMoreRule('isShow3')">
                                <i class="collect-icon"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            isShow1: false,
            isShow2: false,
            isShow3: false,
            links: [
                "https://ccmall.srcb.com/bankcoas/newmb/card?taokaId=64030117&mobile=&branchNm=2100&recmmdId=CPYX02&validate=20991231",
                
                "https://ccmall.srcb.com/bankcoas/newmb/card?taokaId=64030117&mobile=&branchNm=2100&recmmdId=CPYX25&validate=20991231",
                "https://ccmall.srcb.com/bankcoas/newmb/card?taokaId=64030117&mobile=&branchNm=2100&recmmdId=CPYX38&validate=20991231",
                "https://ccmall.srcb.com/bankcoas/newmb/card?taokaId=64030117&mobile=&branchNm=2100&recmmdId=CPYX39&validate=20991231",
                "https://ccmall.srcb.com/bankcoas/newmb/card?taokaId=64030117&mobile=&branchNm=2100&recmmdId=CPYX40&validate=20991231",
                "https://ccmall.srcb.com/bankcoas/newmb/card?taokaId=64030117&mobile=&branchNm=2100&recmmdId=CPYX41&validate=20991231",
                "https://ccmall.srcb.com/bankcoas/newmb/card?taokaId=64030117&mobile=&branchNm=2100&recmmdId=CPYX44&validate=20991231",
                "https://ccmall.srcb.com/bankcoas/newmb/card?taokaId=64030117&mobile=&branchNm=2100&recmmdId=CPYX45&validate=20991231",
                "https://ccmall.srcb.com/bankcoas/newmb/card?taokaId=64030117&mobile=&branchNm=2100&recmmdId=CPYX46&validate=20991231",
                "https://ccmall.srcb.com/bankcoas/newmb/card?taokaId=64030117&mobile=&branchNm=2100&recmmdId=CPYX47&validate=20991231",
                "https://ccmall.srcb.com/bankcoas/newmb/card?taokaId=64030117&mobile=&branchNm=2100&recmmdId=CPYX48&validate=20991231",
            ],
            currentLink: "",
        };
    },
    mounted() {
        let type = this.$route.query.type;

        if (type) {
            switch (type) {
                case "mirror":
                    this.$store.commit("changeMirror", 1);
                    this.currentLink = this.links[1];
                    break;
                default:
                    let index = type.match(/\d+?$/)[0];
                    if (index) {
                        this.$store.commit("changeMirror", index);
                        this.currentLink = this.links[index];
                    }
            }
        } else {
            if (this.mirror) {
                this.currentLink = this.links[this.mirror];
            } else {
                this.currentLink = this.links[0];
            }
        }
    },
    computed: {
        ...mapState(["mirror"]),
    },
    methods: {
        changeMoreRule(key) {
            this[key] = !this[key];
            this.$test("JY a-detail-2");
        },
        changeTestLink(type) {
            this.$test(`${type}${this.mirror ? this.mirror : ""} a-register-2`);
            this.$listeners.routePusht(this.currentLink);
        },
        checkBrowser() {
            var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                //在微信中打开
                return "wechat";
            }
            if (ua.match(/WeiBo/i) == "weibo") {
                //在新浪微博客户端打开
                return "weibo";
            }
            return "wechat";
        },
    },
};
</script>

<style lang="scss" scoped>
</style>